import angular from 'angular';
import uiRouter from 'angular-ui-router';

import CheckinComponent from './checkin.component';

import CheckinSettings from './settings/settings';

const checkinModule = angular.module('tinaba.components.checkin', [
  uiRouter,
  CheckinSettings.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('checkin', {
    url: '/checkin',
    template: '<checkin></checkin>',
    redirect: 'checkin.settings',
    data: {
      services: true // show services in sidenav
    }
  });
})

.component('checkin', CheckinComponent);

export default checkinModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/checkin/checkin.js
 **/